var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIraq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.874C24.8366 32.874 32 25.7106 32 16.874C32 8.03747 24.8366 0.874023 16 0.874023C7.16344 0.874023 0 8.03747 0 16.874C0 25.7106 7.16344 32.874 16 32.874Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.874023C9.12061 0.874023 3.25593 5.21602 0.995239 11.3088H31.0049C28.7442 5.21602 22.8795 0.874023 16.0001 0.874023V0.874023Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32.8741C22.8795 32.8741 28.7442 28.5321 31.0049 22.4392H0.995239C3.25593 28.5321 9.12061 32.8741 16.0001 32.8741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 15.8307C12.1652 15.8307 12.1566 15.8313 12.1479 15.8314V15.8307H9.08931C9.24437 15.2316 9.788 14.7872 10.4348 14.7872V12.7003C8.51687 12.7003 6.95656 14.2606 6.95656 16.1785V17.8829V17.9177H12.1479H12.1739C12.3657 17.9177 12.5217 18.0738 12.5217 18.2655V18.9612H5.56519V21.0481H14.6087V18.2655C14.6087 16.923 13.5164 15.8307 12.1739 15.8307V15.8307Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3914 18.9612V12.7003H15.3044V21.0482H18.7827V18.9612H17.3914Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.348 18.9612V12.7003H22.261V18.9612H21.5653V16.8743H19.4784V21.0482H25.7393V18.9612H24.348Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraq);
export default __webpack_public_path__ + "static/media/iraq.44f713ef.svg";
export { ForwardRef as ReactComponent };